import Modal from 'modal-react-native-web';

export default Modal;
